export default function () {
  return (-this.snapGrid[this.snapGrid.length - 1]);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/framework7/components/swiper/swiper-class/components/core/translate/maxTranslate.js
// module id = null
// module chunks = 